var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import style from './MapTypeControl-hashed.scss';

var MapTypeControlCtrl = function () {
    function MapTypeControlCtrl($element) {
        _classCallCheck(this, MapTypeControlCtrl);

        this.element = $element;

        if (window.google && window.google.maps) {
            this.mapsApi = window.google.maps;
        } else {
            throw new Error('google map api not found');
        }

        this.active = '' + style.active;
    }

    _createClass(MapTypeControlCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.mapLoaded.then(function () {
                var buttonContainer = _this.element[0].children[0]; // obtain button container div from component
                _this.roadBtn = buttonContainer.children[0];
                _this.satelliteBtn = buttonContainer.children[1];
                _this.mapInstance.controls[_this.mapsApi.ControlPosition.BOTTOM_LEFT].push(buttonContainer);
            });
        }
    }, {
        key: 'setRoadMap',
        value: function setRoadMap() {
            this.mapInstance.setMapTypeId(this.mapsApi.MapTypeId.ROADMAP);
            this.satelliteBtn.classList.remove(this.active);
            this.roadBtn.classList.add(this.active);
        }
    }, {
        key: 'setSatelliteMap',
        value: function setSatelliteMap() {
            this.mapInstance.setMapTypeId(this.mapsApi.MapTypeId.SATELLITE);
            this.roadBtn.classList.remove(this.active);
            this.satelliteBtn.classList.add(this.active);
        }
    }]);

    return MapTypeControlCtrl;
}();

MapTypeControlCtrl.$inject = ['$element'];
export default MapTypeControlCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/ca/components/MapTypeControl/MapTypeControlCtrl.js
// module id = 1489
// module chunks = 0